module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "input-focus-modal",
      "height": 150,
      "adaptive": true
    },
    on: {
      "opened": _vm.opened
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "30px",
      "text-align": "center"
    }
  }, [_c('input', {
    ref: "email",
    staticClass: "huge-font",
    attrs: {
      "type": "text",
      "placeholder": "email"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa893a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/InputFocusModal.vue
// module id = 33
// module chunks = 0